import { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { cachedGet } from 'Utils/cachedGet';

const LAST_FOLDER_KEY = 'flowsFolder';

export const useFolderList = () => {
    const [folders, setFolders] = useState([]);

    const fetchFolders = useCallback(() => {
        cachedGet('/folders').then((res) => setFolders(res.data.folders || [])).catch(() => {});
    }, []);

    useEffect(() => { fetchFolders(); }, [fetchFolders]);

    return { folders, fetchFolders };
};

export const useFolders = () => {
    const { folders, fetchFolders } = useFolderList();
    const [modal, setModal] = useState({ open: false, parentId: null, editFolder: null });
    const [searchParams] = useSearchParams();

    const viewParam = searchParams.get('view');
    const folderParam = viewParam ? searchParams.get('folder') : sessionStorage.getItem(LAST_FOLDER_KEY);
    const view = (viewParam || (folderParam ? 'folders' : 'all')) === 'folders' ? 'folders' : 'all';
    const folderId = folderParam ? Number(folderParam) : null;

    const selectedFolder = (view === 'folders' && folderId != null) ? folderId : 'all';
    const isSearchAll = selectedFolder === 'all' && !!searchParams.get('search');
    const listFolder = isSearchAll ? 'any' : selectedFolder;

    useEffect(() => {
        if (selectedFolder === 'all') {
            sessionStorage.removeItem(LAST_FOLDER_KEY);
        } else {
            sessionStorage.setItem(LAST_FOLDER_KEY, String(selectedFolder));
        }
    }, [selectedFolder]);

    const openCreateFolder = useCallback((parentId = selectedFolder === 'all' ? null : selectedFolder) => {
        setModal({ open: true, parentId, editFolder: null });
    }, [selectedFolder]);

    const openRenameFolder = useCallback((folder) => {
        setModal({ open: true, parentId: null, editFolder: folder });
    }, []);

    const closeFolderModal = useCallback(() => {
        setModal((prev) => ({ ...prev, open: false }));
    }, []);

    return {
        folders,
        fetchFolders,
        view,
        folderId,
        selectedFolder,
        isSearchAll,
        listFolder,
        modal,
        openCreateFolder,
        openRenameFolder,
        closeFolderModal,
    };
};
